export const removeAccents = (value: string) =>
    typeof value.normalize !== 'undefined' ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : value;
